
import { User } from '@/types';
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches user profiles from the database
 */
export const fetchUserProfiles = async (userIds: string[]): Promise<Map<string, User>> => {
  if (userIds.length === 0) return new Map();

  try {
    const { data: profiles, error: profilesError } = await supabase
      .from('profiles')
      .select('*')
      .in('id', userIds);

    if (profilesError) throw profilesError;

    // Create a map of user profiles by ID
    const userMap = new Map<string, User>();

    profiles?.forEach(profile => {
      userMap.set(profile.id, {
        id: profile.id,
        name: profile.name || `User ${profile.id.substring(0, 4)}`,
        email: profile.email || null,
        imageUrl: profile.image_url || null,
        isSample: profile.is_sample ?? false,
      });
    });

    // Fall back to basic user objects for any users without profiles
    userIds.forEach(id => {
      if (!userMap.has(id)) {
        userMap.set(id, {
          id: id,
          name: `User ${id.substring(0, 4)}`,
          email: null,
          imageUrl: null,
        });
      }
    });

    return userMap;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    return new Map();
  }
};
